import axios from 'axios';
import { servicePath } from '../../constants/defaultValues';
const { observable } = require('mobx');

const controlStore = observable({
    item: null,
    selectedItems: [],
    selectControlId: '',
    userCode: '',
    userName: '',
    dEui: '',
    modemNo: '',
    modemId: '',
    deviceSn: '',    
    memo: '',
    sImgList: [],

    name: '',
    lati: '',
    longi: '',
    rlati: '',
    rlongi: '',
    addr1: '',
    addr2: '',
    imgIndex: 0,

    opType: '',
    maker: '',
    ctrlType: '',
    modelCode: '',
    instType: '',
    lampType: '',
    lampCapa: '',
    instDate: '',
    regDate: '',
    controlSn: '',

    instDateNative: '',
    deviceSn: '',

    selectedOpType : '-',
    selectedMaker : '-',
    selectedCtrlType : '-',
    selectedModelCode : '-',
    selectedInstType : '-',
    selectedLampType : '-',
    selectedLampCapa : '-',

    selectedOnDiffG : '+',
    selectedOffDiffG : '+',
    selectedNightType : '',
    selectedRestType : '',
    selectedUseCds : '',
    selectedDimm1 : '',
    selectedDimm2 : '',
    selectedDimm3 : '',
    selectedEventType : '',
    searchTxt: '',

    onTime: '',
    offTime: '',
    
    // 점등편차
    onDiff: '',
    onDiffG: '+',
    // 소등편차
    offDiff: '',
    offDiffG: '+',
    
    // 심야소등
    nightType: '',
    stDate: '',
    edDate: '',
    stTime: '',
    edTime: '',

    // 휴식
    restType: '',
    restStDate: '',
    restEdDate: '',

    marjin: '',

    useCds: '',
    eventType: '',

    ccId: '',

    onFTime: 10,
    onTime: 0,

    dimm1use: '',
    dimm1time: '',
    dimm1v: '',
    dimm2use: '',
    dimm2time: '',
    dimm2v: '',
    dimm3use: '',
    dimm3time: '',
    dimm3v: '', 
    
    o_ccId: '',

    o_onDiff: '',
    o_onDiffG: '+',
    o_offDiff: '',
    o_offDiffG: '+',
    
    o_nightType: '',
    o_stDate: '',
    o_edDate: '',
    o_stTime: '',
    o_edTime: '',

    o_restType: '',
    o_restStDate: '',
    o_restEdDate: '',
    o_marjin: '',

    o_useCds: '',
    o_eventType: '',

    o_dimm1use: '',
    o_dimm1time: '',
    o_dimm1v: '',
    o_dimm2use: '',
    o_dimm2time: '',
    o_dimm2v: '',
    o_dimm3use: '',
    o_dimm3time: '',
    o_dimm3v: '',

    isNeedRefresh: false,
    isStartRefresh: false,
    refreshHandle: null,
    totalItem: '',
    installItem: '',

    list: [],
    isLoaded: false,

    //fetchData(globalStore.userCode, queryId.gubun, 
    // selectedOpOption.id, selectedUserOption.id, selectedMakerOption.id, selectedCtrlOption.id, controlStore.searchTxt) ;
    fetchData(userCode, gubun, opOption, userOption, makerOption, ctrlOption, searchText, orderOption) {

      controlStore.isLoaded = false;
      var apiUrl = `${servicePath}/device_v10.php?cmd=list1`;
      if (userCode>2) {
        apiUrl = `${apiUrl}&user=${userCode}`
      } else {
        apiUrl = `${apiUrl}&user=${userOption}`
      }
      apiUrl = `${apiUrl}&gubun=${gubun}`
      apiUrl = `${apiUrl}&op=${opOption}`
      apiUrl = `${apiUrl}&maker=${makerOption}`
      apiUrl = `${apiUrl}&ctlr=${ctrlOption}`
  
      apiUrl = `${apiUrl}&orderBy=${orderOption}&search=${searchText}`
      console.log('controlStore device-table.js', apiUrl);
      controlStore.selectControlId = 0
      axios
        .get(
          apiUrl
        )
        .then((res) => {
          return res.data;
        })
        .then((data) => {
          //console.log(data.data);

          this.list = data.data;
          // setItems(data.data.map(x=>{ return { ...x,img : x.img.replace("img/","img/products/")}}));
          //setSelectedItems([]);
          controlStore.isLoaded = true;
        });
    },
    fetchCount(userCode) {
      // http://bitsw.co.kr/api/lora/count_v01.php?cmd=list&user=220      
      var apiUrl = `${servicePath}/count_v01.php?cmd=list`;
      apiUrl = `${apiUrl}&user=${userCode}`;
      console.log('Req Count User', userCode)
      axios
        .get(
          apiUrl
        )
        .then((res) => {
          return res.data;
        })
        .then((data) => {
          //console.log(data);

          controlStore.totalItem = data.totalItem;
          controlStore.installItem = data.installItem;
          //console.log(data.data, controlStore.installItem, controlStore.totalItem);
        });

    },
    updateImgs() {
      const sImgs = JSON.stringify(controlStore.sImgList);
      //console.log( controlStore.selectControlId, sImgs);

      var apiUrl = `${servicePath}/device_v06.php?cmd=imgupdate`;
      apiUrl = `${apiUrl}&id=${controlStore.selectControlId}`
      apiUrl = `${apiUrl}&img=${sImgs}`
      //console.log('controlStore update img', apiUrl);
      axios
        .get(
          apiUrl
        )
        .then((res) => {
          //console.log('list Count', controlStore.list.length);
          controlStore.list.forEach(item => {
            //console.log(item.id, controlStore.selectControlId);
            if (item.id == controlStore.selectControlId) {
              console.log('org', item.img);
              console.log('updated ', item.id,sImgs);
              item.img = sImgs;
              //item.img2 = controlStore.sImgs;
            }
          });
          
          return res.data;
        })
        .then((data) => {
          console.log(data);
        });
    }

});


const gihoOptions = [
  { id: '+', label: '+' },
  { id: '-', label: '-' },
];

const gubunOptions = [
  { id: 'A', label: 'OFF / OFF' },
  { id: 'B', label: 'ON / ON' },
  { id: 'C', label: 'ON / OFF' },
];

const cdsOptions = [
  { id: '0', label: '미사용' },
  { id: '1', label: '사용' },
];

const useOptions = [
  { id: '0', label: '미사용' },
  { id: '1', label: '사용' },
];


const eventOptions = [
  { id: '0', label: '전체' },
  { id: '1', label: '장애' },
];


function ConvGubunCode(item)
{
  if (item==null) return '-';
  var ret =  gubunOptions.find((x) => x.id == item)
  if (ret==null) return '-';
  return ret.label;
}

function ConvCdsCode(item)
{
  if (item==null) return '-';
  var ret =  cdsOptions.find((x) => x.id == item)
  if (ret==null) return '-';
  return ret.label;
}

function ConvUseCode(item)
{
  if (item==null) return '미사용';
  var ret =  cdsOptions.find((x) => x.id == item)
  if (ret==null) return '미사용';
  return ret.label;
}


function ConvEventCode(item)
{
  if (item==null) return '-';
  var ret =  eventOptions.find((x) => x.id == item)
  if (ret==null) return '-';
  return ret.label;
}


const opOptions = [
  { id: '0', label: '-' },
  { id: '2', label: '설치 대기' },
  { id: '3', label: '설치 완료' },
  { id: '4', label: '기기 철거' },
];




// const makerOptions = [
//   { id: '0', label: '-' },
//   { id: '1', label: '신성일렉콤' },
//   { id: '2', label: '동선기업' },
//   { id: '200', label: '기타' },
// ];



const ctrlOptions = [
  { id: '0', label: '-' },
  { id: '1', label: '양방향 LORA 보안등' },
  { id: '2', label: '양방향 LTE 보안등' },
  { id: '3', label: 'GPS 보안등' },
  { id: '4', label: '전자식 보안등' },
  { id: '5', label: 'LTE 가로등' },
  { id: '6', label: 'GPS 가로등' },
];



// const instOptions = [
//   { id: '0', label: '-' },
//   { id: '1', label: '지주대 설치' },
//   { id: '2', label: '벽' },
// ];


// const modelOptions = [
//   { id: '0', label: '-' },
//   { id: '1', label: 'SSB-2020R' },
//   { id: '20', label: 'SSB-500M' },
//   { id: '21', label: 'SSB-500G' },
//   { id: '30', label: 'SSB-400G' },
//   { id: '31', label: 'SSB-400E' },
//   { id: '40', label: 'SSB-300M' },
//   { id: '41', label: 'SSB-300G' },
//   { id: '100', label: 'SSC-500G' },
// ];



// const lampTypeOptions = [
//   { id: '0', label: '-' },
//   { id: '1', label: 'LED' },
//   { id: '2', label: '고압나트륨' },
//   { id: '3', label: '세라믹메탈' },
//   { id: '4', label: 'UCD' },
//   { id: '5', label: '무전극' },
// ];


// const lampCapaOptions = [
//   { id: '0', label: '-' },
//   { id: '50', label: '50W' },
//   { id: '60', label: '60W' },
//   { id: '75', label: '75W' },
//   { id: '100', label: '100W' },
//   { id: '125', label: '125W' },
//   { id: '150', label: '150W' },
//   { id: '200', label: '200W' },
// ];


function getIntToDate(aDate) {
  let iDate = Number(aDate); 
  let iMon = parseInt(iDate / 100);
  let iDay = (iDate % 100);
  return iMon.toString() +'월 '+iDay.toString()+'일' ;
}

function getIntToTime(aTime) {
  let iTime = Number(aTime); 
  let iHour = parseInt(iTime / 100);
  let iMin = (iTime % 100);

  const sHour = ("0"+iHour.toString()).slice(-2);
  const sMin = ("0"+iMin.toString()).slice(-2);

  return sHour +':'+sMin;
}

function ConvOnOffStateCode(item)
{
  //console.log(item);
  if (item.pwFail === '1') 
  {
    return '정전'
  } else {
    //if (timeDiff<(240*60) ) {
      if (item.state === '0') {
        if (item.onOff === '0') return '소등';
        if (item.onOff === '1') return '점등';
        if (item.onOff === '2') return '강제점등';
        if (item.onOff === '3') return '주간점등';
      } else if (item.state === '2') {
        return '통신이상';
      } else if (item.state === '1') {
        if (item.eventCode === '1') return '안정기장애';
        else if (item.eventCode === '2') return '램프고장';
        else return '정전';
      }
    //} else {
      // 최종 통신시간이 4시간 이상이면 통신이상
    // }
  }

  if (item==null) return '-';
  if (item=="1") ;
  if (item=="0") 
  return '-';
}


function ConvOpTypeCode(item)
{
  if (item==null) return '-';
  var ret =  opOptions.find((x) => x.id == item)
  if (ret==null) return '-';
  return ret.label;
}

// function ConvMakerCode(item)
// {
//   if (item==null) return '-';
//   var ret =  makerOptions.find((x) => x.id == item)
//   if (ret==null) return '-';
//   return ret.label;
// }

function ConvCtrlCode(item)
{
  if (item==null) return '-';
  var ret =  ctrlOptions.find((x) => x.id == item)
  if (ret==null) return '-';
  return ret.label;
}

// function ConvInstTypeCode(item)
// {
//   if (item==null) return '-';
//   var ret =  instOptions.find((x) => x.id == item)
//   if (ret==null) return '-';
//   return ret.label;
// }

// function ConvModelCode(item)
// {
//   if (item==null) return '-';
//   var ret =  modelOptions.find((x) => x.id == item)
//   if (ret==null) return '';

//   return ret.label;
// }

// function ConvLampTypeCode(item)
// {
//   if (item==null) return '-';
//   var ret =  lampTypeOptions.find((x) => x.id == item)
//   if (ret==null) return '-';
//   return ret.label;
// }

// function ConvLampCapaCode(item)
// {
//   if (item==null) return '-';
//   var ret =  lampCapaOptions.find((x) => x.id == item)
//   if (ret==null) return '-';
//   return ret.label;
// }


export { controlStore, 
  gihoOptions, gubunOptions, cdsOptions, eventOptions,
  opOptions, ctrlOptions, useOptions,
  
  // makerOptions,  instOptions,
  // modelOptions, lampTypeOptions, lampCapaOptions,
  
  // ConvMakerCode, ,
  // ConvInstTypeCode, ConvModelCode, ConvLampTypeCode, ConvLampCapaCode,


  ConvOpTypeCode, ConvCtrlCode, ConvUseCode,
  ConvOnOffStateCode, ConvGubunCode, ConvCdsCode, ConvEventCode,
  getIntToTime, getIntToDate
};
